export default __webpack_public_path__ + "static/media/DSC00366.2af8fe8c.JPG";